import React from 'react'
import ComptoirContainer from '../../section/ComptoirContainer/ComptoirContainer'

const Comptoir = () => {
  return (
    <div>

<ComptoirContainer/>

    </div>
  )
}

export default Comptoir